<template>
    <div class="flex justify-between text-sm" :class="margin">
        <div class="text-gray-700">
            <slot name="left"></slot>
        </div>
        <div class="flex-1 text-right">
            <slot name="right"></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        margin: {
            type: String,
            default: "mb-3"
        },
    },
};
</script>
